/**
 * @generated SignedSource<<372f201f199e9b7ce13968b0426006ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
import { FragmentRefs } from "relay-runtime";
export type TeamAdminLayoutFeature_TeamFeature$data = {
  readonly __typename: string;
  readonly id: string;
  readonly todoCategoryTeam?: {
    readonly category: {
      readonly icon: TodoCategoryIcon | null;
      readonly title: string;
    };
  };
  readonly " $fragmentType": "TeamAdminLayoutFeature_TeamFeature";
};
export type TeamAdminLayoutFeature_TeamFeature$key = {
  readonly " $data"?: TeamAdminLayoutFeature_TeamFeature$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamAdminLayoutFeature_TeamFeature">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamAdminLayoutFeature_TeamFeature",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategoryTeam",
          "kind": "LinkedField",
          "name": "todoCategoryTeam",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TodoCategory",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TodoCategoryTeamFeature",
      "abstractKey": null
    }
  ],
  "type": "TeamFeature",
  "abstractKey": "__isTeamFeature"
};

(node as any).hash = "ba899fadcc0e1dcc1aa80c15b276756e";

export default node;
